import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { lazy, Suspense } from "react";

const Platform = lazy(() => import("@/components/Platform").then(m => ({ default: m.Platform })));
const Products = lazy(() => import("@/components/Products").then(m => ({ default: m.Products })));
const Marketplace = lazy(() => import("@/components/Marketplace").then(m => ({ default: m.Marketplace })));
const Stack = lazy(() => import("@/components/Stack").then(m => ({ default: m.Stack })));
const ThemePreview = lazy(() => import("@/components/ThemePreview").then(m => ({ default: m.ThemePreview })));
const Waitlist = lazy(() => import("@/components/Waitlist").then(m => ({ default: m.Waitlist })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

export default function App() {
  return (
    <div className="min-h-screen bg-su-background text-su-text-primary">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <Platform />
          <Products />
          <Marketplace />
          <Stack />
          <ThemePreview />
          <Waitlist />
          <Footer />
        </Suspense>
      </main>
    </div>
  );
}
